export default "__VITE_ASSET__1f561022__"